import { showError } from "../hooks/toast";
import i18n from "i18next";

export const handleError = error => {
  console.error(error);
  showError(i18n.t('error.500'));
};
